import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildSavedToursUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.SAVED_TOURS}/${endpoint ? endpoint : ""}`

export const savedToursService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSavedTours: builder.query({
      query: (params) => ({
        url: buildSavedToursUrl("tours_json"),
        method: "GET",
        params: params,
      }),
    }),
    getSavedToursSessionsJson: builder.query({
      query: (params) => ({
        url: buildSavedToursUrl("sessions_json"),
        method: "GET",
        params: params,
      }),
    }),
    getSavedToursSession: builder.query({
      query: (sessionKey) => ({
        url: buildSavedToursUrl(`session_json/${sessionKey}`),
        method: "GET",
      }),
    }),
    getSavedToursFilterOptions: builder.query({
      query: (params) => ({
        url: buildSavedToursUrl("filter_options"),
        method: "GET",
        params: params,
      }),
    }),
    createSavedTours: builder.mutation({
      query: (body) => ({
        url: buildSavedToursUrl("create"),
        method: "POST",
        body: body,
      }),
    }),
    deleteSavedTour: builder.mutation({
      query: (id) => ({
        url: buildSavedToursUrl(id),
        method: "DELETE",
      }),
    }),
    updateSavedTour: builder.mutation({
      query: ({ id, ...body }) => ({
        url: buildSavedToursUrl(id),
        method: "PATCH",
        body,
      }),
    }),
    applySavedTourDiscount: builder.mutation({
      query: ({ id, discount_type, discount_value }) => ({
        url: buildSavedToursUrl(`${id}/apply_discount`),
        method: "PATCH",
        body: { discount_type, discount_value },
      }),
    }),
    removeSavedTourDiscount: builder.mutation({
      query: (id) => ({
        url: buildSavedToursUrl(`${id}/remove_discount`),
        method: "DELETE",
      }),
    }),
    // ids — id записей SavedTour, отмеченных чекбоксами на странице
    // сессии. Скидка ставится ТОЛЬКО на них, а не на всю сессию.
    applyBulkDiscount: builder.mutation({
      query: ({ session_key, ids, discount_type, discount_value }) => ({
        url: buildSavedToursUrl("bulk_discount"),
        method: "POST",
        body: { session_key, ids, discount_type, discount_value },
      }),
    }),
    removeBulkDiscount: builder.mutation({
      query: ({ session_key, ids }) => ({
        url: buildSavedToursUrl("remove_bulk_discount"),
        method: "DELETE",
        body: { session_key, ids },
      }),
    }),
    // Генерирует (и сразу отзывает предыдущий) токен для расширения
    // Tour Importer, упакованный вместе с доменом в одну строку
    // (connection_string) — её пользователь целиком копирует в
    // единственное поле настроек расширения.
    generateExtensionToken: builder.mutation({
      query: () => ({
        url: buildSavedToursUrl("generate_extension_token"),
        method: "POST",
      }),
    }),
    revokeExtensionToken: builder.mutation({
      query: () => ({
        url: buildSavedToursUrl("revoke_extension_token"),
        method: "POST",
      }),
    }),
    getExtensionToken: builder.query({
      query: () => ({
        url: buildSavedToursUrl("extension_token"),
        method: "GET",
      }),
    }),

    getSavedTourShareText: builder.query({
      query: ({ id, template_id, format = "text" }) => ({
        url: buildSavedToursUrl(`${id}/share_text`),
        method: "GET",
        params: template_id ? { template_id, format } : { format },
      }),
    }),
    getSavedToursSessionShareText: builder.query({
      query: ({ session_key, template_id, format = "text" }) => ({
        url: buildSavedToursUrl(`session/${session_key}/share_text`),
        method: "GET",
        params: template_id ? { template_id, format } : { format },
      }),
    }),
  }),
})

export const {
  useLazyGetSavedToursQuery,
  useLazyGetSavedToursSessionsJsonQuery,
  useLazyGetSavedToursSessionQuery,
  useLazyGetSavedToursFilterOptionsQuery,
  useCreateSavedToursMutation,
  useDeleteSavedTourMutation,
  useUpdateSavedTourMutation,
  useApplySavedTourDiscountMutation,
  useRemoveSavedTourDiscountMutation,
  useApplyBulkDiscountMutation,
  useRemoveBulkDiscountMutation,
  useLazyGetExtensionTokenQuery,
  useGenerateExtensionTokenMutation,
  useRevokeExtensionTokenMutation,
  useLazyGetSavedTourShareTextQuery,
  useLazyGetSavedToursSessionShareTextQuery,
} = savedToursService
